import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useAuth } from '../teal-react/utils/token';
import { useSave } from '../graphql/hooks';
import SimpleGrid from '../teal-react/components/organisms/SimpleGrid';
import { Alert } from '@mui/material';

const Profile = () => {
  const [show, setShow] = React.useState(false);
  const { user } = useAuth();
  const save = useSave('user');
  return (
    <SimpleGrid
      items={[
        {
          size: 4,
          content: <div />,
        },
        {
          size: 4,
          content: (
            <>
              <SimpleForm
                header={`Hello ${user?.firstname}!`}
                subheader="Change Password"
                resetOnSave
                model={{
                  id: user?.id,
                }}
                fields={[
                  {
                    name: 'password',
                    label: 'Password',
                    validate: { required: true },
                    password: true,
                  },
                ]}
                save={(props: any) => {
                  const { modified } = props;

                  save({
                    id: user?.id,
                    password: modified.password,
                  });
                  setShow(true);
                }}
              />
              {show ? (
                <Alert severity="success">
                  Your password has been updated.
                </Alert>
              ) : null}
            </>
          ),
        },
      ]}
    />
  );
};

export default Profile;
